// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_KIt","cls2":"TranslationModal-cls2_b3J TranslationModal-cls1_KIt"};